module.exports = __webpack_public_path__ + "img/contact-img.c74bea58.png";